import 'firebase/storage';
import * as firebase from 'firebase/app';
import { v4 as uuidv4 } from 'uuid';
import { Component, Vue, Watch } from 'vue-property-decorator';
import moment, { duration } from 'moment';
import { Calendar } from '@/models/calendar/Calendar';
import { ValidationRules } from '@/utils/validation-rules';
import { optimizePhotos, uploadImage } from '@/utils/upload-image';
import { fileSizeToMB, validFileSize10MB } from '@/utils/fileSizeToMB';
import { SocialClubs } from '@/models/SocialClubs';
import { EventsTypes } from '@/enums/EventsTypes';
import {
    RecurringEventsType,
    RecurringRepeatOnDay,
    RecurringRepeatOnNumber,
    RecurringRepeatType,
} from '@/enums/RecurringEventsType';
import { CreateEvent } from '@/models/calendar/CreateEvent';
import { FacilitySettingsModel } from '@/models/FacilitySettings';
import { EventsTypesOptions } from '@/consts/EventsTypesOptions';
import { PremiumServiceEventTypes } from '@/enums/PremiumServiceEventTypes';
import { EditRecurringEventTypes } from '@/enums/EditRecurringEventTypes';
import { dateFormats } from '@/consts/DateTimeFormats';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import { convertTimeDurationTo24hFormat, convertTimeTo24HourInArray, setTimeForDate } from '@/utils/dateTimeFormat';
import { EventLocationsMixin } from '@/mixins/EventLocations.ts';
import { toTranslationKey } from '@/utils/stringFormat';
import PublishEventToWingDialog from '@/views/calender/view-calendar-item/PublishEventToWingDialog.vue';
import ScheduledPublishEventsDialog from '@/views/calender/view-calendar-item/ScheduledPublishEventsDialog.vue';
import DuplicateEvent from '@/views/calender/new-calendar-item/DuplicateEvent.vue';
import { Week } from '@/consts/Week';
import { PremiumServiceParticipantsLimit } from '@/enums/PremiumServiceParticipantsLimit';
import TimeRangeDropdown from '@/components/pickers/TimeRangeDropdown.vue';
import GalleryPhotosUploadDlg from '@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue';
import { GalleryImage } from '@/models/GalleryImage';
import { waitResizedImage } from '@/utils/wait-resized-image';

@Component({
    methods: {duration},
    components: {
        VueTimepicker,
        TimeRangeDropdown,
        DuplicateEvent,
        PublishEventToWingDialog,
        GalleryPhotosUploadDlg,
        ScheduledPublishEventsDialog
    },
    mixins: [EventLocationsMixin]
})
export default class NewCalendarItem extends Vue {
    menu1 = false
    menu2 = false
    loading = false;
    imgLoading = false;
    isFormValid = true;
    eventsTypes = EventsTypes;
    EventsTypesOptions = [];
    maxNameLength = 125;
    openDuplicateEventDialog = false;
    flexHeight = 500;
    duplicatedEvent = null;
    ifDuplicateEventEnter = false;
    isOpenScheduldEventsDialog = false;
    isLoadingMeetingTimes = false;
    recurringType = RecurringEventsType;
    recurringTypes = Object.values(RecurringEventsType).map(x => ({text: toTranslationKey(x), value: x}))
    recurringRepeatType = RecurringRepeatType;
    recurringRepeatTypes = Object.values(RecurringRepeatType).map(x => ({text: toTranslationKey(x), value: x}))
    week = Week;
    recurringRepeatOnNumbers = Object.values(RecurringRepeatOnNumber).map(x => ({text: toTranslationKey(x), value: x}))
    recurringRepeatOnDays = Object.values(RecurringRepeatOnDay).map(x => ({text: toTranslationKey(x), value: x}))

    eventData: CreateEvent = new CreateEvent();

    minDate = moment(new Date()).format('YYYY-MM-DD'); //today
    maxDate = moment(new Date()).add(1, "year").format('YYYY-MM-DD');

    hintDateHormat = ''
    hintTimeHormat = ''

    startDateSelected = ''
    endDateSelected = ''
    endDateFormatted = '';
    selectedResidents = [];
    availibleResidents = this.residents;

    startDateValid = true;
    endDateValid = true;
    endMaxDateValid = true;

    startDateTimeValid = true;
    endDateTimeValid = true;
    editRecurringEventType = "";
    premiumServiceParticipantsLimit = PremiumServiceParticipantsLimit;

    startDateInput = null
    pickers = {
        start: false,
        end: false
    };

    time = {
        start: moment().format(this.$store.state.facilityModule.selectedFacility.timeFormat),
        end: moment().add(1, "h").format(this.$store.state.facilityModule.selectedFacility.timeFormat)
    };

    recurringMeetingTimeSlot = '';

    isTimeRangeValid = true;
    isOffice365Event = false;
    isLoadedMsCalendarEvents = false;
    isLoadingMsCalendarEvents = false;
    eventDates = [];
    busyEventDates = [];
    msCalendarEvents = [];

    durationMins = 15;
    availableTimes = [];
    currentRoomLocation = null;

    async created() {
        this.checkTimeRouteParams();

        const calendarFilter = this.$store.state.calenderModule.mainCalendarFilters;

        this.eventData.wing = calendarFilter?.wingName || 'All';
        (this as any).selectedWingsIds = calendarFilter?.wingsIds || [];

        this.eventData.facilityId = this.currentFacility;

        if (this.$route.params.dateSelected && moment(this.$route.params.dateSelected).diff(moment(this.minDate), 'days') > 0) {
            this.startDateSelected = this.$route.params.dateSelected
        } else {
            this.startDateSelected = this.minDate
        }

        this.EventsTypesOptions = EventsTypesOptions.filter((x: any) => ![this.eventsTypes.PremiumServices, this.eventsTypes.ConciergeRequest].includes(x.value)).map(x => ({value: x.value, name: this.$t(x.name)}));

        await this.$store.dispatch('getAdditionalServices');
        await this.$store.dispatch('getSocialClubList');
    }

    async mounted() {
        const dateFormat = dateFormats.find(x => x.format == this.facility.dateFormat)
        this.hintDateHormat = dateFormat ? dateFormat.name : dateFormats[0].name
        this.hintTimeHormat = this.facility.timeFormat.includes('A') ? this.facility.timeFormat.replace(' A', '') : this.facility.timeFormat

        if (this.$route.params.duplicate) {
            this.openDuplicateEventDialog = true;
            this.duplicatedEvent = this.$route.params.duplicate;

            this.editRecurringEventType = this.$route.params.editRecurringEventType;
            this.eventData.invitees = this.duplicatedEvent.invitees[0]

            if (this.duplicatedEvent.isRecurring) {
                if (this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                    const calendarRecurringEvents = await this.getFollowingRecurringEvents(this.$route.params.recurringData)
                    this.eventData.startDate = moment(calendarRecurringEvents[0].start).format("YYYY-MM-DD")
                    this.eventData.endDate = moment(calendarRecurringEvents[0].start).format("YYYY-MM-DD")
                    this.startDateSelected = this.eventData.startDate
                    this.endDateSelected = this.eventData.endDate
                    this.duplicatedEvent.isRecurring = false;
                }
                if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                    const calendarRecurringEvents = await this.getFollowingRecurringEvents(this.$route.params.recurringData)
                    this.eventData.startDate = moment(calendarRecurringEvents[0].start).format("YYYY-MM-DD")
                    this.eventData.endDate = moment(calendarRecurringEvents[calendarRecurringEvents.length - 1].end).format("YYYY-MM-DD")
                    this.startDateSelected = this.eventData.startDate
                    this.endDateSelected = this.eventData.endDate
                }
                if (this.editRecurringEventType === EditRecurringEventTypes.AllEvents) {
                    const calendarRecurringEvents = await this.getRecurringEvents(this.duplicatedEvent.parentEventId)
                    this.eventData.startDate = moment(calendarRecurringEvents[0].start).format("YYYY-MM-DD")
                    this.eventData.endDate = moment(calendarRecurringEvents[calendarRecurringEvents.length - 1].end).format("YYYY-MM-DD")
                    this.startDateSelected = this.eventData.startDate
                    this.endDateSelected = this.eventData.endDate
                }
            } else {
                this.startDateSelected = moment(this.duplicatedEvent.start).format("YYYY-MM-DD")
                this.endDateSelected = moment(this.duplicatedEvent.end).format("YYYY-MM-DD")
            }

            const startDate = moment(this.duplicatedEvent.start)
            const endDate = moment(this.duplicatedEvent.end)
            this.ifDuplicateEventEnter = true;
            this.time.start = startDate.format(this.facility.timeFormat)
            this.time.end = endDate.format(this.facility.timeFormat)
            this.eventData.isRecurring = this.duplicatedEvent.isRecurring
            this.eventData.recurringType = this.duplicatedEvent.recurringType
            this.eventData.recurringRepeatType = this.duplicatedEvent.recurringRepeatType
            this.eventData.recurringRepetitions = this.duplicatedEvent.recurringRepetitions
            this.eventData.monthlyRepeatOn = this.duplicatedEvent.monthlyRepeatOn
            this.eventData.noEndDate = this.duplicatedEvent.noEndDate
            this.eventData.name = this.duplicatedEvent.name
            this.eventData.VideoLink = this.duplicatedEvent.VideoLink
            this.eventData.description = this.duplicatedEvent.description
            this.eventData.wing = this.duplicatedEvent.wing
            this.eventData.isPublished = this.duplicatedEvent.isPublished
            this.eventData.scheduledPublishDateTime = this.duplicatedEvent.scheduledPublishDateTime || null
            this.eventData.location = this.duplicatedEvent.location
            this.eventData.facilityId = this.duplicatedEvent.facilityId
            this.eventData.hostEmailAddress = this.duplicatedEvent.hostEmailAddress
            this.eventData.imageUrl = this.duplicatedEvent.imageUrl
            this.eventData.isBroadcast = this.duplicatedEvent.isBroadcast
            this.eventData.isExternallyHosted = this.duplicatedEvent.isExternallyHosted
            this.eventData.isVirtualEvent = this.duplicatedEvent.isVirtualEvent
            this.eventData.type = this.duplicatedEvent.type
            this.eventData.duplicatedFrom = this.duplicatedEvent.id
            this.eventData.allDay = this.duplicatedEvent.allDay
            this.eventData.office365EventId = this.duplicatedEvent.office365EventId
            this.eventData.wingsIds = this.duplicatedEvent.wingsIds || [];
            (this as any).selectedWingsIds = this.eventData.wingsIds
        }
    }

    get startDateFormatted() {
        if (!this.hintDateHormat || !this.startDateSelected) return ''

        return moment(this.startDateSelected).format(this.hintDateHormat)
    }

    get isEnableRoomBooking() {
        return this.$store.state.facilityModule.selectedFacility.isEnableRoomBooking;
    }

    onEndDateFormattedInput(value: string) {
        if (value) {
            const parsedDate = moment(value, this.hintDateHormat, true);
            if (parsedDate.isValid()) {
                this.endDateSelected = parsedDate.toISOString();
            } else {
                this.endDateSelected = null;
            }
        } else {
            this.endDateSelected = null;
            this.endDateFormatted = '';
        }
    }

    get socialClubsDropdown(): SocialClubs[] {
        return this.$store.state.socialClubModule.socialClubsDropdown;
    }

    get premiumServices() {
        return this.$store.state.additionalServicesModule.additionalServices
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
            .filter(service => service.type === PremiumServiceEventTypes.EventBased);
    }

    get currentFacility(): string {
        return this.$store.state.authModule.currentFacility;
    }

    get rules(): object {
        return {
            name: [ValidationRules.required, ValidationRules.max(this.maxNameLength)],
            start: [ValidationRules.required],
            end: [
                ValidationRules.required,
                v => {
                    const start = moment(this.time.start, this.facility.timeFormat);
                    const end = moment(this.time.end, this.facility.timeFormat);
                    return (
                        moment(end).isAfter(start) ||
                        this.$i18n.messages[this.$i18n.locale]['ValidationRules.EventEndDateCannotBeBeforeStartDate']
                    );
                }
            ],
            VideoLink: [ValidationRules.url],
            cost: [ValidationRules.positiveNumber],
            type: [ValidationRules.required],
            invitees: [ValidationRules.required],
            email: [ValidationRules.email],
            concierge: [
                v => !!this.eventData.goingDetails.length || this.$i18n.messages[this.$i18n.locale]['ValidationRules.Required']
            ],
            recurringEndDate: [
                () => {
                    if (!this.eventData.isRecurring)
                        return true;
                    else if (this.eventData.noEndDate || this.endDateFormatted) {
                        return true;
                    }

                    return false
                }
            ],
        };
    }

    get facility(): FacilitySettingsModel {
        return this.$store.state.facilityModule.selectedFacility;
    }

    get residents() {
        const residents = this.$store.state.residentModule.residentsShortData;
        return residents.filter(
            resident => !this.eventData.going?.includes(resident.id)
        );
    }

    get calendarEvents() {
        return this.$store.state.calenderModule.calenderEvents;
    }

    get selectedPremiumService() {
        return this.premiumServices.find(x => x.id === this.eventData.invitees);
    }

    get eventWarning(): string {
        const warning: string = (this.$i18n.messages[this.$i18n.locale]['NewCalendarItem.CreateCalendarEventWarning'] as string);
        return warning.replace(`[${this.$i18n.messages[this.$i18n.locale]['NewCalendarItem.CreateCalendarEventWarningHere'] as string}]`, `<a href="/concierge-events">${this.$t('NewCalendarItem.CreateCalendarEventWarningHere')}</a>`);
    }

    openConciergeEvents(event) {
        if (event.target.tagName === 'A') {
            event.preventDefault()
            this.$router.push(event.target.getAttribute('href'));
        }
    }

    onTimeRangeChange(timeRange) {
        this.time.start = timeRange.startTime
        this.time.end = timeRange.endTime
        this.isTimeRangeValid = timeRange.isValid
        this.updateMaxDate()
    }

    async getRecurringEvents(parentEventId: string) {
        return await firebase
            .firestore()
            .collection("calender")
            .where("facilityId", "==", this.currentFacility)
            .where("parentEventId", "==", parentEventId)
            .orderBy("start").get().then(querySnapshot => {
                const resList: Array<any> = [];

                querySnapshot.docs.forEach(x => {
                    const thisRes = x.data();
                    thisRes.id = x.id;
                    thisRes.start = moment(thisRes.start.seconds * 1000).toDate();
                    thisRes.end = moment(thisRes.end.seconds * 1000).toDate();
                    resList.push(thisRes);
                });

                return resList;
            });
    }

    async getFollowingRecurringEvents(recurringData: any) {
        const startEventRangeDate = moment(recurringData.recurringRange.start).startOf('date').toDate()
        const endEventRangeDate = moment(recurringData.recurringRange.end).endOf('date').toDate()

        return await firebase
            .firestore()
            .collection("calender")
            .where("facilityId", "==", this.currentFacility)
            .where("parentEventId", "==", recurringData.parentEventId)
            .where("start", ">=", startEventRangeDate)
            .where("start", "<=", endEventRangeDate)
            .get()
            .then(querySnapshot => {
                const resList: Array<any> = [];

                querySnapshot.docs.forEach(x => {
                    const thisRes = x.data();
                    thisRes.id = x.id;
                    thisRes.start = moment(thisRes.start.seconds * 1000).toDate();
                    thisRes.end = moment(thisRes.end.seconds * 1000).toDate();
                    resList.push(thisRes);
                });

                return resList;
            });
    }

    @Watch("time.start")
    onStartDateChange(start: string) {
        if (!this.ifDuplicateEventEnter && !this.eventData.allDay) {
            this.time.end = moment(start, this.facility.timeFormat).add(1, "h").format(this.facility.timeFormat);
        } else {
            this.ifDuplicateEventEnter = false;
        }
    }

    @Watch("eventData.type")
    onEventDataChange(eventType) {
        if (eventType === this.eventsTypes.ConciergeRequest) {
            this.eventData.goingDetails = [];
            this.eventData.going = [];
        }

        if (eventType !== this.eventsTypes.PremiumServices) {
            this.eventData.participantLimitNumber = null;
            this.eventData.participantLimit = "";
            this.eventData.invitees = [];
        }
    }

    @Watch("eventData.invitees")
    onEventDataInviteesChange() {
        if (this.selectedPremiumService?.participantLimit === this.premiumServiceParticipantsLimit.LimitPerEvent) {
            this.eventData.participantLimitNumber = 1;
            this.eventData.participantLimit = this.premiumServiceParticipantsLimit.LimitPerEvent;
        } else {
            this.eventData.participantLimitNumber = null;
            this.eventData.participantLimit = "";
        }
    }

    beforeMount(): void {
        this.$store.dispatch("getSocialClubList");
        this.$store.dispatch("getFacility");
    }

    eventTypesEnum() {
        return EventsTypes
    }

    onResidentsSelect(e) {
        this.addResidents()
    }

    allowedHours(v) {
        return moment(v).isAfter();
    }

    async saveEventImage(e) {
        const path = `${this.currentFacility}/events/coverImages/${uuidv4()}`;
        const file: File | Blob | any = await optimizePhotos(e.target.files[0], '');
        const fileSizeInMegabytes = fileSizeToMB(file?.size);

        if (!validFileSize10MB(fileSizeInMegabytes)) {
            (this.$refs.inputUpload as any).value = null;
            return;
        }

        uploadImage({
            path,
            file,
            onStart: () => {
                this.imgLoading = true;
            },
            onComplete: async storage => {
                const uploadedImageUrl = await storage.snapshot.ref.getDownloadURL();
                const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);

                try {
                    const resizedImageUrl = await waitResizedImage(10, resizedImageRef);
                    this.eventData.imageUrl = uploadedImageUrl;
                    this.eventData.thumbnailUrl = resizedImageUrl;
                } catch (e) {
                    this.eventData.imageUrl = uploadedImageUrl;
                    this.eventData.thumbnailUrl = uploadedImageUrl;
                }

                this.imgLoading = false;
            }
        });
    }

    async updateLocationValue(value) {

        this.eventData.noEndDate = false
        
        const locations = this.$store.state.eventLocationModule.eventLocations;
    
        if (!locations?.length) {
            await this.setOffice365EventState(false);
            return;
        }
    
        if (!this.isEnableRoomBooking) {
            await this.setOffice365EventState(false);
            return;
        }
    
        this.currentRoomLocation = locations.find(location => location.name === value);
    
        if (this.currentRoomLocation?.isInOffice365) {
            if (!this.calendarEvents.length) {
                await this.$store.dispatch('getCalenderEvents');
            }
    
            await this.setOffice365EventState(true);
            await this.findMeetingTimes();
    
            const locationEvents = this.calendarEvents.filter(event => event.location?.length > 0);
    
            for (const event of locationEvents) {
                if (event.location === value) {
                    const date = new Date(event.startISOString).toISOString().split('T')[0];
                    this.eventDates.push(date);
                    this.busyEventDates.push(date);
                }
            }
    
            await this.loadMsCalendarEvents();
        } else {
            await this.setOffice365EventState(false);
        }
    }

    async loadMsCalendarEvents(){
        if(this.isOffice365Event) {
            const params = {
                facilityId: this.currentFacility,
                range: {
                    startDateTime: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                    endDateTime: moment().endOf('day').add(1, 'month').format('YYYY-MM-DDTHH:mm:ss')
                }
            }

            this.isLoadingMsCalendarEvents = true
            await this.$store.dispatch('msCalendarView', params).then(response => {
                this.isLoadedMsCalendarEvents = true

                if (response.data?.data?.length > 0) {
                    this.msCalendarEvents = response.data.data
                    this.eventDates = this.eventDates.concat(response.data.data.map(x=>x.date));
                    this.isLoadingMsCalendarEvents = false
                }
            })
        }
    }

    async setOffice365EventState(state) {
        this.isOffice365Event = state;

        this.updateMaxDate()
    }

    updateMaxDate(){
        if(this.isOffice365Event === true){
            if((this.eventData.recurringType === RecurringEventsType.Monthly
                || (this.eventData.recurringType === RecurringEventsType.Custom &&
                    this.eventData.recurringRepeatType === RecurringRepeatType.Month))){
                this.maxDate = moment(this.startDateSelected).add(1, "year").format('YYYY-MM-DD');
            }
            else{
                this.maxDate = moment(this.startDateSelected).add(50, "days").format('YYYY-MM-DD');
            }
        }
        else{
            this.maxDate = moment(new Date()).add(1, "year").format('YYYY-MM-DD');
        }
    }

    getEventColor(date){
        if (this.busyEventDates.includes(date) || this.msCalendarEvents.some(d => d.date === date && d.items.length > 0)) {
            return'orange';
        }
        else if (this.msCalendarEvents.some(d => d.date === date && d.items.length <= 0)) {
            return'green';
        }

        return 'white';
    }

    saveAsDraft() {
        this.openScheduldEventsDialog()
    }

    onScheduldEventsDialogResponse(response) {

        if (response.isScheduled === true) {
            this.createEvent(false, response.scheduledPublishDateTime)
            this.closeScheduldEventsDialog()
        } else {
            this.createEvent(false, null)
        }
    }

    publishEvent() {
        this.createEvent(true, null)
    }

    async createEvent(isPublished: boolean, scheduledPublishDateTime: any): Promise<void> {

        if(this.isMsEventValid() === false) return

        const form = this.$refs.form as any;
        const validated = form.validate();
        const validatedDateTime = this.validateDateTime();
        let splitStartTimeArray = [];
        let splitEndTimeArray = [];

        if (!validated || !validatedDateTime) return null;

        this.loading = true;

        const channelId = this.eventData.isVirtualEvent ? uuidv4() : null;
        let invitees = ["All"];
        if (this.eventData.invitees.length && (this.eventData.invitees as any) !== "All") {
            invitees = [this.eventData.invitees.toString()];
        }

        this.eventData.startDate = this.startDateSelected;
        this.eventData.endDate = this.endDateSelected;
        this.eventData.isPublished = isPublished;
        this.eventData.scheduledPublishDateTime = scheduledPublishDateTime
        this.eventData.office365ResourceEmail = this.currentRoomLocation?.office365Email || null

        const formData = {...this.eventData};
        formData.invitees = invitees;

        let eventsData: Calendar[] = [];

        if (this.eventData.isRecurring) {
            formData.startDate = !formData.startDate ? (formData.startDate = moment(new Date()).format(this.hintDateHormat)) : formData.startDate;
            formData.endDate = formData.noEndDate ? null : formData.endDate;

            if (this.isOffice365Event) {
                const meetingTimeSlots = this.recurringMeetingTimeSlot.split('-')
                splitStartTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[0]);
                splitEndTimeArray = convertTimeTo24HourInArray(meetingTimeSlots[1]);
                formData.duration = convertTimeDurationTo24hFormat(`${splitStartTimeArray[0]}:${splitStartTimeArray[1]}-${splitEndTimeArray[0]}:${splitEndTimeArray[1]}`);
            }
            else{
                formData.duration = convertTimeDurationTo24hFormat(`${this.time.start}-${this.time.end}`);
            }

            return await this.$store
                .dispatch("getRecurringEvents", {
                    eventFormData: formData,
                    noEndDate: formData.noEndDate,
                    invitees: formData.invitees,
                    monthlyRepeatOn: formData.monthlyRepeatOn
                })
                .then(async events => {
                    eventsData = events.map(x => {
                        x.channelId = channelId;
                        return x;
                    });

                    const result = await this.createNewEvent(eventsData);

                    if (this.isOffice365Event) {
                        
                        //should be the same date for 'daily'
                        const startDateTime = moment(formData.startDate).set({hour: +splitStartTimeArray[0], minute: +splitStartTimeArray[1]}).format('YYYY-MM-DDTHH:mm:ss');
                        const endDateTime = moment(formData.startDate).set({hour: +splitEndTimeArray[0], minute: +splitEndTimeArray[1]}).format('YYYY-MM-DDTHH:mm:ss');
                
                        //range of recurring events
                        const rangeStartDateTime = moment(formData.startDate).format('YYYY-MM-DD')
                        const rangeEndDateTime = moment(formData.endDate).format('YYYY-MM-DD')

                        const params = {
                            subject: this.eventData.name,
                            roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                            startDateTime: startDateTime,
                            endDateTime: endDateTime,
                            office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
                            facilityId: this.currentFacility,
                            recurrence: {
                                type: formData.recurringType,
                                repeatType: formData?.recurringRepeatType,
                                repetitionsDays: formData?.recurringRepetitionsDays,
                                interval: formData.recurringRepetitions,
                                monthlyRepeatOn: formData.monthlyRepeatOn,
                                startDateTime: rangeStartDateTime,
                                endDateTime: rangeEndDateTime
                            }
                        }

                        this.$store.dispatch('createMsEvent', params).then(async response => {
                            if(response.data?.status === 200){
                                if(response?.data?.data?.id?.length > 0){
                                    return await this.$store.dispatch('setoffice365EventIdForRecurringEvents', {
                                        office365EventId: response?.data?.data?.id,
                                        parentEventId: result[0].parentEventId
                                    })
                                }
                            }
                            else{
                                this.$toast.error(this.$t("NewCalendarItem.ErrorCreatingMsEvent") as string)
                            }
                        });
                    }

                    this.eventData = new CreateEvent();

                    return result
                }).finally(() => {
                    this.loading = false;

                    this.$router.push({
                        name: 'Calendar',
                        params: {currentWeek: formData.startDate},
                    });
                })

        } else {

            formData.endDate = formData.startDate

            let startDateTime = null
            let endDateTime = null

            if (this.isOffice365Event) {
                const startTime = moment(this.time.start, this.facility.timeFormat)
                const newEndTime = moment(this.time.start, this.facility.timeFormat).add(this.durationMins, 'minutes')

                this.time.end = newEndTime.format(this.facility.timeFormat)

                startDateTime = moment(this.startDateSelected).set({
                    hour: startTime.hours(),
                    minute: startTime.minutes()
                }).format('YYYY-MM-DDTHH:mm:ss');

                endDateTime = moment(this.startDateSelected).set({
                    hour: newEndTime.hours(),
                    minute: newEndTime.minutes()
                }).format('YYYY-MM-DDTHH:mm:ss');

                formData.duration = convertTimeDurationTo24hFormat(`${this.time.start}-${this.time.end}`);
            }
            else{
                formData.duration = convertTimeDurationTo24hFormat(`${this.time.start}-${this.time.end}`);
            }

            return this.$store.dispatch("setupCalendarEvent", { newEventData: formData})
                .then(async event => {

                    event.channelId = channelId;
                    eventsData.push(event);

                    const createdEventId = await this.createNewEvent(eventsData);

                    if (this.isOffice365Event) {

                        const params = {
                            subject: this.eventData.name,
                            roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                            startDateTime: startDateTime,
                            endDateTime: endDateTime,
                            office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
                            facilityId: this.currentFacility
                        }

                        return await this.$store.dispatch('createMsEvent', params).then(async response => {
                            if(response.data?.status === 200){
                                if(response?.data?.data?.id?.length > 0){
                                    return await firebase.firestore().collection("calender").doc(createdEventId).update({ office365EventId: response?.data?.data?.id })
                                }
                            }
                            else{
                                this.$toast.error(this.$t("NewCalendarItem.ErrorCreatingMsEvent") as string)
                            }
                        });
                    }

                    this.eventData = new CreateEvent();

                    return createdEventId
                }).finally(() => {
                    this.loading = false;

                    this.$router.push({
                        name: 'Calendar',
                        params: {currentWeek: formData.startDate},
                    });
                })
        }
    }

    async createNewEvent(eventsData: Calendar[]) {

        if (eventsData && eventsData.length === 1) {
            return await this.$store.dispatch("createNewCalenderEvent", eventsData[0]);
        } else {
            return await this.$store.dispatch("createNewCalenderEvents", {events: eventsData});
        }
    }

    allowedDates(val) {
        return val >= this.minDate;
    }


    validateDateTime() {

        const startDate = moment(this.startDateFormatted, this.hintDateHormat)

        if (this.eventData.isRecurring) {

            //for first set
            if (!this.endDateFormatted) return true

            const endDate = moment(this.endDateFormatted, this.hintDateHormat)
            const endTime = this.time.end
            setTimeForDate(endDate, endTime)

            this.endDateValid = endDate.isValid();
            if (this.endDateValid) this.endDateTimeValid = endDate > startDate;
            this.startDateTimeValid = true;

            if (this.eventData.noEndDate == true) {
                this.endDateValid = true;
                this.endDateTimeValid = true;
            }

            this.endMaxDateValid = this.eventData.endDate <= this.maxDate;
        } else {
            const startTime = this.time.start
            setTimeForDate(startDate, startTime)

            //const today = moment(new Date());
            this.startDateValid = startDate.isValid();
            // Check if event in the past
            // this.startDateTimeValid = startDate >= today;
        }

        return this.isDatesValid()
    }

    allDayChange(value) {
        if (value) {

            if (this.facility.timeFormat.includes('A')) {
                this.time.start = '12:00 AM'
                this.time.end = '11:59 PM'
            } else {
                this.time.start = '00:00'
                this.time.end = '23:59'
            }

            this.clearRecurring()
        } else {
            this.time.start = moment().format(this.facility.timeFormat)
        }
    }

    onRecurringChanged(value) {
        if (!value) {
            this.clearRecurring()
        }

        this.findMeetingTimes()

        this.availableTimes = []
    }

    onRecurringRepeatTypeChanged() {
        this.findMeetingTimesForRecurring()
    }

    onRecurringRepetitionsDaysChanged() {
        this.findMeetingTimesForRecurring()
    }

    onRecurringTypeChanged(){
        this.findMeetingTimesForRecurring()
    }

    clearRecurring() {
        this.eventData.noEndDate = false
    }

    isDatesValid() {
        return this.startDateValid && this.endDateValid && this.startDateTimeValid && this.endDateTimeValid && this.endMaxDateValid
    }

    isMsEventValid() {

        if(!this.isOffice365Event) return true

        return this.recurringMeetingTimeSlot?.length > 0 || this.time.start?.length > 0
    }

    addResidents() {
        const residents = this.selectedResidents.map(member => {
            return {
                id: member.id,
                name: member.name,
                email: member?.email || null,
                imageUrl: member.imageUrl
            };
        });

        const residentsIds = this.selectedResidents.map(({id}) => id);

        if (this.eventData.going && this.eventData.attendeesIds) {
            this.eventData.going = [...this.eventData.going, ...residentsIds];
            this.eventData.attendeesIds = [
                ...this.eventData.attendeesIds,
                ...residentsIds
            ];
        } else {
            this.eventData.going = residentsIds;
            this.eventData.attendeesIds = residentsIds;
        }

        if (this.eventData.goingDetails && this.eventData.attendees) {
            this.eventData.goingDetails = [
                ...this.eventData.goingDetails,
                ...residents
            ];
            this.eventData.attendees = [...this.eventData.attendees, ...residents];
        } else {
            this.eventData.goingDetails = residents;
            this.eventData.attendees = residents;
        }

        this.availibleResidents = this.availibleResidents.filter(resident => {
            if (!this.selectedResidents.find(member => member.id === resident.id)) {
                return resident;
            }
        });
        this.selectedResidents = [];
    }

    addAllResidentsToSelected() {
        this.selectedResidents = this.availibleResidents;
        this.addResidents();
    }

    removeResidentFromSelected(resident) {
        const indexAttendeesIds = this.eventData.going.findIndex(
            item => item === resident.id
        );
        const indexAttendees = this.eventData.goingDetails.findIndex(
            item => item.id === resident.id
        );
        this.eventData.going.splice(indexAttendeesIds, 1);
        this.eventData.goingDetails.splice(indexAttendees, 1);
        this.eventData.attendees.splice(indexAttendeesIds, 1);
        this.eventData.attendeesIds.splice(indexAttendees, 1);
        this.availibleResidents.push(resident);
        this.addResidents();
    }

    public decrementParticipantLimitNumber(): void {
        if (this.eventData.participantLimitNumber > 1) {
            this.eventData.participantLimitNumber--;
            this.$forceUpdate();
        }

        if (!this.eventData.participantLimitNumber) {
            this.eventData.participantLimitNumber = 1;
            this.$forceUpdate();
        }
    }

    public incrementParticipantLimitNumber(): void {
        if (!this.eventData?.participantLimitNumber) {
            this.eventData.participantLimitNumber = 1;
        } else {
            this.eventData.participantLimitNumber++;
        }
        this.$forceUpdate();
    }

    public decrementDurationMins(): void {
      
        if (!this.durationMins || this.durationMins <= 15) {
            this.durationMins = 15;
        }
        else {
            this.durationMins = +this.durationMins-15;
        }

        this.$forceUpdate();
        this.findMeetingTimes();
    }

    public incrementDurationMins(): void {

        if (!this.durationMins) {
            this.durationMins = 15;
        }
        else {
            this.durationMins = +this.durationMins+15;
        }

        this.$forceUpdate();
        this.findMeetingTimes();
    }

    public checkTimeRouteParams(): void {
        const timeStart = this.$route.params.timeStart;

        if (timeStart) {
            this.time.start = timeStart;
            this.time.end = moment(timeStart, this.facility.timeFormat).add(1, "h").format(this.facility.timeFormat);
        } else {
            this.time.start = moment().format(this.facility.timeFormat)
        }
    }

    public async findMeetingTimes(){

        if(!this.isOffice365Event) return

        if(this.eventData.isRecurring){

            if(!this.startDateSelected?.length || !this.endDateSelected?.length) {
                this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}]
                return
            }
            else{
                await this.findMeetingTimesForRecurring()
            }
        }
        else{

            if(!this.startDateSelected?.length ) {
                this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}]
                return
            }
            else{
                await this.findMeetingTimesForSingleEvent()
            }
        }

    }

    public async findMeetingTimesForRecurring(): Promise<void> {

        if(!this.eventData.isRecurring || !this.isOffice365Event) return

        this.updateMaxDate()

        this.isLoadingMeetingTimes = true
       
        const startDateTime = moment(this.startDateSelected).startOf('day')

        const endDateTime = moment(this.endDateSelected).endOf('day')

        const params = {
            roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
            office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
            startDateTime: startDateTime.format('YYYY-MM-DDTHH:mm:ss'),
            endDateTime: endDateTime.format('YYYY-MM-DDTHH:mm:ss'),
            recurrence: {
                repetitions:this.eventData?.recurringRepetitions,
                type: this.eventData?.recurringType,
                repeatType: this.eventData?.recurringRepeatType,
                repetitionsDays: this.eventData?.recurringRepetitionsDays,
                monthlyRepeatOn: this.eventData?.monthlyRepeatOn,
            },
            meetingDurationInMins: this.durationMins,
            facilityId: this.currentFacility
        }
        this.$store.dispatch('findMsMeetingTimesForRecurring', params)
            .then(response => {
                if (response.data) {
                    const meetingTimeSuggestions = response.data.data.meetingTimeSuggestions

                    if(meetingTimeSuggestions.length > 0){
                        this.availableTimes = meetingTimeSuggestions[0].times.map(time => {
                            return {text: time, value: time}
                        });
                    }
                    else{
                        this.availableTimes = []
                    }
                    
                } else {
                    this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}];
                }
            }).catch((error) => {
            console.error(error);
        }).finally(() => {
            this.isLoadingMeetingTimes = false
        })
    }

    public async findMeetingTimesForSingleEvent(): Promise<void> {

        this.isLoadingMeetingTimes = true

        const startDateTime = moment(this.startDateSelected).startOf('day').format('YYYY-MM-DDTHH:mm:ss');

        const endDateTime = moment(this.startDateSelected).endOf('day').format('YYYY-MM-DDTHH:mm:ss');

        if (this.isOffice365Event) {
            const params = {
                roomName: this.currentRoomLocation?.isDifferentName ? this.currentRoomLocation.differentName : this.currentRoomLocation.name,
                office365ResourceEmail: this.currentRoomLocation?.office365Email || null,
                startDateTime,
                endDateTime,
                meetingDurationInMins: this.durationMins,
                facilityId: this.currentFacility
            }

            this.$store.dispatch('findMsMeetingTimes', params)
                .then(response => {
                    if (response.data?.data?.length > 0) {
                        this.availableTimes = response.data.data.map(el => {
                            const timeSlot = `${moment(el.meetingTimeSlot?.start.dateTime).format(this.facility.timeFormat)}`;
                            return {text: timeSlot, value: timeSlot}
                        });

                    } else {
                        this.availableTimes = [{text: this.$t("NewCalendarItem.NotAvailableHours"), value: null}];
                    }
                }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.isLoadingMeetingTimes = false
            })

        }
    }

    onChangeEndDateSelected(newVal){
        this.findMeetingTimesForRecurring()
        if (newVal) {
            this.endDateFormatted = moment(newVal).format(this.hintDateHormat);
        } else {
            this.endDateFormatted = '';
        }
    }

    backToCalendar() {
        this.$router.push({
            name: 'Calendar',
            params: {currentWeek: this.$route.params.dateSelected},
        });
    }

    openGalleryPhotos() {
        (this.$refs.GalleryPhotosUploadDlg as any).open();
    }

    openScheduldEventsDialog() {
        this.isOpenScheduldEventsDialog = true
    }

    closeScheduldEventsDialog() {
        this.isOpenScheduldEventsDialog = false
    }

    uploadGalleryPhoto(image: GalleryImage) {
        this.eventData.imageUrl = image.image;
        this.eventData.thumbnailUrl = image?.thumbnailUrl ?? image.image;
        console.log("uploadGalleryPhoto ", this.eventData)
    }

    addRepeatOption() {
        this.eventData.monthlyRepeatOn.push(
          {
              "position": RecurringRepeatOnNumber.First,
              "day": RecurringRepeatOnDay.Monday
          }
        )
    }

    removeRepeatOption(index) {
        this.eventData.monthlyRepeatOn.splice(index, 1);
    }

    @Watch('selectedWingsIds')
    onSelectedWingsIds(newValue) {
        this.eventData.wingsIds = newValue;
    }

    @Watch('eventData.recurringRepetitions')
    onRecurringRepetitionsChanged(newValue) {
        if(newValue > 0){
            this.findMeetingTimesForRecurring()
        }
    }
}
